import React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
export default styled(Dialog)(function () {
  return {
    "& .MuiDialog-root.MuiDialog-paper": {
      borderRadius: 12
    }
  };
});